import React, { Component, createContext, useEffect, useState } from 'react';
import Titulo from "../../generico/TituloPagina";
import { TrasladoCuotaPaso1 } from './TrasladoCuotaPaso1';
import { TrasladoCuotaPaso2 } from './TrasladoCuotaPaso2';
import { TrasladoCuotaPaso3 } from './TrasladoCuotaPaso3';
import { CustomStepWizard } from '../../generico/CustomStepWizard';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import SubsidiosService from '../../../services/solicitudes/SubsidiosService';
import { trackPromise } from 'react-promise-tracker';
import { Popup } from 'react-leaflet';

export const ModifFechaVtoCreditoContext = createContext();

const ModifFechaVtoCredito = () => {

    const location = useLocation();

    let param = null;

    if( location.state ) param = location.state.param;

    const initialState = {
        cuentasOrigen: [],
        ctaOrigenSele: { value: "-1", label: "--Seleccione--" },
        itemSelected: { value: "-1", label: "--Seleccione--" },
        ctaFullData: null,
        moneda: "",
        fechaSeleccionada:null,
        interesAPagar:null,
        diferenciaDias:null
    }

    const [state, setState] = useState({
        ...initialState,
        credito : param
    });

    useEffect(() => {
        getCuentas();
    }, []);

    const getCuentas = () => {
        trackPromise(
            SubsidiosService.getCuentas().then(response => {
                const { codigo, mensaje, resultadoAH } = response.data;
                if (codigo === "0") {
                    const cuentasMap = resultadoAH.map(value => ({
                        ...value,
                        idAhorro: value.ahorro,
                        disponible: value.saldoTotal
                    }));
                    setState(prevState => ({ ...prevState, cuentasOrigen: cuentasMap, moneda: "GS" }));
                } else {
                    Popup.queue(notifiPopup("Info", mensaje));
                }
            })
        );
    }

    const notifiPopup = (titulo, mensaje) =>{
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });
    }

    const ModifFechaVtoCreditoContextValue = { state, setState };

    const stepWizardHeaders = ["Datos de Pago", "Datos de Verificación", "Confirmación"];

    return (
        <div className="content-wrapper">
            <Titulo texto="Pago de Sepelio" />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <CustomStepWizard contextValue={ModifFechaVtoCreditoContextValue} isLazyMount={true} stepHeaders={stepWizardHeaders} >
                                        <TrasladoCuotaPaso1 />
                                        <TrasladoCuotaPaso2 />
                                        <TrasladoCuotaPaso3 />
                                    </CustomStepWizard>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ModifFechaVtoCredito;